// extracted by mini-css-extract-plugin
module.exports = {"projectImageContainer":"Home_projectImageContainer__UinEx","valuesImageContainer":"Home_valuesImageContainer__p881M"};